<script setup>
import {useRoute} from 'vue-router'
import { onMounted } from 'vue'

onMounted(() => {
  document.body.style.width = '100%';
  document.body.classList.add('my-page-body');
})

const route = useRoute()
</script>

<!-- src/views/IframeView.vue -->
<template>
  <iframe
      :src="route.meta.url"
      allow="clipboard-write https://safedocs.myamh.org; clipboard-read https://safedocs.myamh.org"
      style="width:100%; height:100vh; border:none;"
  />
</template>

<style scoped>

</style>

